import React, { Component } from 'react'

import { connect } from 'react-redux';

import {bindActionCreators} from "redux";

import Firebase from 'firebase/app'

import {CCAppEventLogger, Constants, CCButton, CCInput, colors, strings, CCAck, DataActionTypes as DataAT, CCActions} from "./../../cc-imports";

import PropTypes from 'prop-types'

// import './prediction_entry_creation.css'
import './../../styles/css/screens/PredictionEntryCreation/prediction-entry-creation.css'
import CCErrorBoundary from "../../components/CCErrorBoundary/CCErrorBoundary";
// import './prediction_entry_creation_320.css'

class PredictionEntryCreation extends Component {

    static propTypes = {
        openSignIn : PropTypes.func,
        league : PropTypes.object,
        onAck:PropTypes.func
    }

    static defaultProps = {
        openSignIn : ()=>{},
        onAck:()=>{},
        league : undefined
    }

    constructor(props) {
        super(props)
        this.initialState = {
            league : {},
            prediction : undefined,
            error : undefined,
            created : false
        }
        this.state = this.initialState;

        this._updateLeague=this._updateLeague.bind(this);
        this._getTitle=this._getTitle.bind(this);
        this._getInputLabel=this._getInputLabel.bind(this);
        this._validate=this._validate.bind(this);
        this._isSubmitDisabled=this._isSubmitDisabled.bind(this);
        this._createEntry=this._createEntry.bind(this);
        this._onAck=this._onAck.bind(this);
    }

    _updateLeague(league){
        this.setState({league, error:undefined});
    }

    componentDidMount(){
        //console.log("prediction entry creation loaded -----")
        const {league} = this.props;
        if(league){
            const leagueCache = this.props.cache[league.id];
            if(leagueCache){
                this.setState(leagueCache);
            }
            else {
                this._updateLeague(league);
            }
        }
    }

    _getTitle(league){
        switch (league.category){
            case Constants.leagueCategory.QUICK_PREDICTION:
            case Constants.leagueCategory.LIVE_PREDICTION:
                return strings('live_prediction_leagues');
                break;
            case Constants.leagueCategory.PREDICTION:
                return strings('target_prediction_leagues');

                break;
            default:
                return strings('target_prediction_leagues');
        }
    }

    _getInputLabel(league) {
        var qps = league.quickPredictionDetails;
        switch (league.category){
            case Constants.leagueCategory.QUICK_PREDICTION:
            case Constants.leagueCategory.LIVE_PREDICTION:
                return strings('predict_what_message', {teamName:qps.team.toUpperCase(),startOver:qps.startOver,endOver:qps.endOver});
                break;
            case Constants.leagueCategory.PREDICTION:
                return strings('predict_score');
                break;
            default:
                return strings('predict_score');
        }
    }

    _validate(prediction) {
        let league = this.state.league;
        if (prediction < 0) {
            return strings('runs_cannot_be_negative_value')
        }
        if(prediction > 1000) {
            return strings('please_select_valid_score')
        }
        return;
    }

    _isSubmitDisabled(){
        return this.state.prediction==undefined;
    }

    _createEntry() {
        const {userId, user} = this.props;
        if(userId){
            let league = this.state.league;
            CCAppEventLogger.logAppEvent('CreateEntryClicked',
                {   'league_category':league.category,
                    'league_type':league.type,
                    'match_key':league.match.key,
                    loggedIn:true
                });

            var entry = {};
            entry.prediction = this.state.prediction;
            entry.creator = user;
            entry.league = league;
            entry.coins = league.coinsPerEntry;


            Firebase.auth().currentUser.getIdToken(false).then((idToken)=> {
                this.props.actions.createEntry(entry, {userId: userId, accessToken: idToken}).then(()=> {
                    const {entriesType,entriesReqStatus, entriesError}=this.props;

                    if(entriesType==DataAT.CREATE){
                        if (entriesReqStatus==Constants.reqStatus.FAI) {
                            this.setState({error: entriesError})
                        }
                        else {
                            this.setState({error: undefined, created:true});
                            //this.props.actions.getLeague(league.id,{accessToken:idToken}, DataAT.AUTO_REFRESH);
                            //this.props.actions.getUser({userId : userId});
                        }
                    }
                })
            })
        }
        else {
            let league = this.state.league;
            CCAppEventLogger.logAppEvent('CreateEntryClicked',
                {   'league_category':league.category,
                    'league_type':league.type,
                    'match_key':league.match.key,
                    loggedIn:false
                });
            this.props.actions.addToCache(league.id,this.state);
            this.props.openSignIn();
        }
    }

    _onAck(){
        this.props.actions.removeFromCache(this.state.league.id);
        this.setState(this.initialState, ()=>{
            this.props.onAck();
        });
    }
    render() {
        const {prediction}=this.state;
        const {entriesType, entriesReqStatus} = this.props

        return (
            <CCErrorBoundary>
            <div>
                {
                    this.state.created==false ?
                            <div className={'prediction_container'}>
                                <div className={'prediction_title_container'}>
                                    <h2 className={'title'}>{this._getTitle(this.state.league)}</h2>
                                </div>

                                    <h1 className={'score_info_title'}>{strings('predict_the_target_score_of_the_match')}</h1>
                                    <CCInput value={prediction} customValidate={this._validate} required={true} immediate={true} onEndEditing={(prediction) => { this.setState({prediction}) }} labelProps={{numberOfLines : 2}} type={"number"} label={this._getInputLabel(this.state.league)}/>

                                <div className={'prediction_btn_container'}>
                                    <CCButton className={'btn-h3'} titleClassName={'prediction-btn-txt'} analytics={{event:'ManualSignIn'}} title={strings('submit')} style={{marginTop: 5}}
                                              onPress={this._createEntry} loading={entriesType==DataAT.CREATE && entriesReqStatus==Constants.reqStatus.PEN} disabled={this._isSubmitDisabled()}/>

                                </div>

                                {
                                    this.state.error &&
                                    <div>
                                        <h1 className={'target-prediction-entry-creation-error'}>{this.state.error}</h1>
                                    </div>
                                }
                            </div>
                            :
                            <div>
                                <CCAck buttonText={strings('close')} title={this._getTitle(this.state.league)} detail={strings('your_entry_created')} type={"success"} onAck={this._onAck}/>
                            </div>
                }
            </div>
            </CCErrorBoundary>
        )
    }
}


export default connect(state => ({
        modals: state.modals,

        user: state.user.user,
        userId: state.user ? state.user.user ? state.user.user.id : undefined : undefined,

        entries: state.entries,
        entriesById : state.entries.byId,
        entriesByLeague : state.entries.byLeague,
        entriesByCreatorId : state.entries.byCreatorId,
        entriesPages : state.entries.pages,
        entriesReqStatus : state.entries.reqStatus,
        entriesError : state.entries.error,
        entriesType : state.entries.type,

        cache : state.cache.cache
    }),
    (dispatch) => ({
        actions: bindActionCreators({...CCActions}, dispatch),
        dispatch: dispatch
    })
)(PredictionEntryCreation);


// WEBPACK FOOTER //
// ./src/app/screens/PredictionEntryCreation/PredictionEntryCreation.js